import { buildApiUrl } from "../../config.js";
import React, { useState, useEffect } from "react";
import { FaUserEdit, FaTimes } from "react-icons/fa";
import { toast } from "react-toastify";

const EditUserModal = ({ user, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobileNo: "",
    username: "",
    role: "sales executive",
    accountStatus: "active",
  });

  useEffect(() => {
    if (user) {
      setFormData({
        name: user.name || "",
        email: user.email || "",
        mobileNo: user.mobileNo || "",
        username: user.username || "",
        role: user.role || "sales executive",
        accountStatus: user.accountStatus || "active",
      });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    const updatedUser = { ...formData };

    try {
      const response = await fetch(
        buildApiUrl(`/api/users/edit-user/${user._id}`),
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatedUser),
        }
      );

      if (response.ok) {
        toast.success("User updated successfully!");
        onSubmit();
        onClose();
      } else {
        toast.error("Failed to update user.");
      }
    } catch (error) {
      toast.error("An error occurred while updating the user.");
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-70 z-50 transition-opacity duration-300">
      <div className="bg-white rounded-lg shadow-2xl w-full max-w-sm mx-4 p-4 transform transition-all duration-300 scale-100">
        <div className="flex items-center justify-between border-b border-gray-200 pb-2">
          <div className="flex items-center gap-2">
            <FaUserEdit className="text-indigo-600" size={16} />
            <h2 className="text-lg font-semibold text-gray-800">Edit User</h2>
          </div>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 transition-colors"
          >
            <FaTimes size={16} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="mt-3 space-y-3">
          <div>
            <label
              htmlFor="name"
              className="block text-xs font-medium text-gray-600 mb-1"
            >
              Name
            </label>
            <input
              id="name"
              name="name"
              type="text"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
            />
          </div>

          <div>
            <label
              htmlFor="email"
              className="block text-xs font-medium text-gray-600 mb-1"
            >
              Email
            </label>
            <input
              id="email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
            />
          </div>

          <div>
            <label
              htmlFor="mobileNo"
              className="block text-xs font-medium text-gray-600 mb-1"
            >
              Mobile No
            </label>
            <input
              id="mobileNo"
              name="mobileNo"
              type="text"
              value={formData.mobileNo}
              onChange={handleChange}
              required
              className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
            />
          </div>

          <div>
            <label
              htmlFor="username"
              className="block text-xs font-medium text-gray-600 mb-1"
            >
              Username
            </label>
            <input
              id="username"
              name="username"
              type="text"
              value={formData.username}
              onChange={handleChange}
              required
              className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
            />
          </div>

          <div>
            <label
              htmlFor="role"
              className="block text-xs font-medium text-gray-600 mb-1"
            >
              Role
            </label>
            <select
              id="role"
              name="role"
              value={formData.role}
              onChange={handleChange}
              required
              className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
            >
              <option value="admin">Admin</option>
              <option value="sales executive">Sales Executive</option>
              <option value="finance">Finance</option>
              <option value="client">Client</option>
            </select>
          </div>

          <div>
            <label
              htmlFor="accountStatus"
              className="block text-xs font-medium text-gray-600 mb-1"
            >
              Account Status
            </label>
            <select
              id="accountStatus"
              name="accountStatus"
              value={formData.accountStatus}
              onChange={handleChange}
              required
              className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
            >
              <option value="active">Active</option>
              <option value="blacklisted">Blacklisted</option>
            </select>
          </div>

          <div className="flex justify-end items-center pt-3 border-t border-gray-200 gap-2">
            <button
              type="button"
              onClick={onClose}
              className="px-3 py-2 bg-gray-200 text-gray-700 text-xs rounded-md hover:bg-gray-300 transition-colors duration-200"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-3 py-2 bg-indigo-600 text-white text-xs rounded-md hover:bg-indigo-800 transition-colors duration-200 flex items-center gap-1"
            >
              <FaUserEdit size={12} />
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default React.memo(EditUserModal);
